import { createSignal } from 'solid-js';
import { auth } from '~/config/auth';
import { createMagicDoorContext } from '~/contexts/utils';
import { createMutation } from '~/utils/resource';
import type { OtpAuthDto } from '@magicdoor/auth';
import type { CompanyOptionDto, SendOtpDto } from '~/swagger/Api';

export enum OtpLoginStep {
  InputPhone = 'InputPhone',
  SelectCompany = 'SelectCompany',
  InputVerifyCode = 'InputVerifyCode',
}

export const [OtpLoginProvider, useOtpLogin] = createMagicDoorContext('OtpLogin', () => {
  const [loginStep, setLoginStep] = createSignal<OtpLoginStep>(OtpLoginStep.InputPhone);
  const [companies, setCompanies] = createSignal<CompanyOptionDto[]>([]);

  const sendOtp = createMutation(async (data: SendOtpDto) => {
    const result = await auth.sendOTP(data);
    if (result.companies?.length) {
      setLoginStep(OtpLoginStep.SelectCompany);
      setCompanies(result.companies);
    } else {
      setLoginStep(OtpLoginStep.InputVerifyCode);
    }
    return result;
  });

  const verifyOtp = createMutation(async (data: OtpAuthDto, remember?: boolean) => {
    try {
      const result = await auth.verifyOTP(data);

      if (result.interactionCode) {
        if (remember) {
          sessionStorage.setItem('auth_remember', 'true');
        } else {
          sessionStorage.removeItem('auth_remember');
        }

        await auth.initiateOAuthFlow(result.interactionCode);

        return result;
      }

      return result;
    } catch {
      setLoginStep(OtpLoginStep.InputPhone);
    }
  });

  return {
    loginStep,
    setLoginStep,
    sendOtp,
    verifyOtp,
    companies,
  };
});
